import { render } from "./ProdutosTable.vue?vue&type=template&id=710efb14&scoped=true"
import script from "./ProdutosTable.vue?vue&type=script&lang=js"
export * from "./ProdutosTable.vue?vue&type=script&lang=js"

import "./ProdutosTable.vue?vue&type=style&index=0&id=710efb14&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710efb14"]])

export default __exports__